<p-menubar>
    <ng-template pTemplate="start" style="margin-top: auto">
      <div>Fælleskommunalt Administrationsmodul</div>
    </ng-template>
    <ng-template pTemplate="end">
      <span>
        Du er logget på som
        <span class="usernameFlag" (click)="op.toggle($event)">
          <a>
            {{ userName }}
            <i
              class="material-icons"
              style="vertical-align: middle; line-height: 0; margin-left: -5px"
            >
              arrow_drop_down
            </i>
          </a>
        </span>
      </span>
      <!-- <button pButton label="Logout" icon="pi pi-fw pi-power-off" (click)="logout()"></button> -->
    </ng-template>
  </p-menubar>
  
  <p-overlayPanel #op [style]="{ width: '300px' }">
    <ng-template pTemplate>
      <table>
        <tr>
          <td>Bruger:</td>
          <td>
            {{ userName }}
          </td>
        </tr>
        <tr>
          <td>Rolle:</td>
          <td>
            {{ userRole }}
          </td>
        </tr>
      </table>
      <hr />
      <span class="logoutBtn" (click)="logout()"> Log af </span>
    </ng-template>
  </p-overlayPanel>
  